module.exports = __webpack_public_path__ + "img/app_logo_dark_hr_007.1dcfa3ae.png";